import axios from 'axios';

const BASE = cvp_endpoint;
const BASE_URL = BASE + '/cvp/';

export const cvp_url = BASE;

export const cvp_post = async(endpoint, payload) => {
    try {
        const response = await axios(BASE_URL + endpoint, {
            method: 'POST',
            headers: {
                'content-type': 'application/json',
            },
            data: payload,
        });
        return response.data;
    } catch (error) {
        console.log(error);
        throw error;
    }
};

export const cvp_get = async(endpoint) => {
    try {
        const response = await axios(BASE_URL + endpoint, {
            method: 'GET',
            headers: {
                'content-type': 'application/json',
            }
        });
        return response.data;
    } catch (error) {
        console.log(error);
        throw error;
    }
};
